import styled from 'styled-components'

const HorseRankListStyled = styled.div`
  .rank-list-container {
    margin-right: 27px;
    gap: 10px;

    .rank-box {
      height: 50px;

      .rank {
        font-size: 16px;
        line-height: 20px;
        width: 22px;
      }
    }
  }

  .horse-list-container {
    gap: 10px;
  }
`

export default HorseRankListStyled
